<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <template>
          <v-col cols="12" sm="6" md="6" v-if="!item['@id']">
            <v-file-input
              v-model="item.file"
              accept=".stl,.3mf"
              :error-messages="fileErrors"
              :label="$t('global.fileinput')"
              required
            >
              <template v-slot:selection="{ text, index }">
                <v-chip v-if="index < 2" color="secondary" dark label small>
                  {{ text }} - {{ convertToMo(item.file.size) }} Mo
                </v-chip>
                <span v-else-if="index === 2">
                  +{{ item.file.length - 2 }}
                </span>
              </template>
            </v-file-input>
          </v-col>
        </template>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('designfile.nda') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.nda"
                  :error-messages="ndaErrors"
              ></v-switch>

            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model="item.name"
              :error-messages="nameErrors"
              :label="$t('global.name')"
              required
              @input="$v.item.name.$touch()"
              @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6" v-show="typeProp == null || item.type == null">
          <v-combobox
              v-if="typeSelectItems"
              v-model="item.type"
              :items="typeSelectItems"
              :error-messages="typeErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('designfile.type')"
              item-text="name"
              item-value="@id"
          />
        </v-col>


      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6" v-show="customerProp == null">
          <v-combobox
              v-if="customerSelectItems"
              v-model="item.customer"
              :items="customerSelectItems"
              :error-messages="customerErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('designfile.customer')"
              item-text="name"
              item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
              v-if="tagSelectItems"
              v-model="item.tags"
              :items="tagSelectItems"
              :error-messages="tagErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('designfile.tags')"
              item-text="name"
              item-value="@id"
              :search-input.sync="search"
              multiple
              chips
              @change="changeTag()"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('global.no_result') }} "<strong>{{ search }}</strong>". {{ $t('global.addcombo1') }} <kbd>enter</kbd> {{ $t('global.addcombo2') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <v-chip
                  v-if="item === Object(item)"
                  v-bind="attrs"
                  color="accent"
                  :input-value="selected"
                  label
              >
                     <span class="pr-2">
                       {{ item.name }}
                     </span>
                <v-icon
                    small
                    @click="parent.selectItem(item)"
                >
                  mdi-close
                </v-icon>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>


      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">

          <v-text-field
              v-model="item.ref"
              :error-messages="refErrors"
              :label="$t('designfile.ref')"
              required
              @input="$v.item.ref.$touch()"
              @blur="$v.item.ref.$touch()"
          />

        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
              v-model="item.comment"
              :error-messages="commentErrors"
              :label="$t('designfile.comment')"
              auto-grow
              rows="1"
              row-height="15"
              @input="$v.item.comment.$touch()"
              @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';
import userHasAccess from '../../mixins/AccessMixin';

export default {
  name: 'DesignFileForm',
  mixins: [userHasAccess,validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },
    customerProp: {
      type: [Object, String],
      required: false,
      default: null,
    },
    typeProp: {
      type: Object,
      required: false,
      default: null,
    },
  },

  mounted() {
    this.typeGetSelectItems();
    this.customerGetSelectItems();
    this.tagGetSelectItems();
  },

  data() {
    return {
      file: null,
      name: null,
      type: null,
      ref: null,
      comment: null,
      tags: null,
      search: null,
      customer: null,
      nda: null,
    };
  },

  computed: {
    isLoading() {
      return (this.isLoading_type || this.isLoading_tag || this.isLoading_customer
      );
    },
    ...mapFields('designfiletype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    ...mapFields('tag', {
      tagSelectItems: 'selectItems',
      isLoading_tag : 'isLoading'
    }),
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);


      return errors;
    },
    customerErrors() {
      const errors = [];

      if (!this.$v.item.customer.$dirty) return errors;

      has(this.violations, 'customer') && errors.push(this.violations.customer);

      return errors;
    },
    tagErrors() {
      const errors = [];

      if (!this.$v.item.tags.$dirty) return errors;

      has(this.violations, 'tags') && errors.push(this.violations.tags);


      return errors;
    },
    refErrors() {
      const errors = [];

      if (!this.$v.item.ref.$dirty) return errors;

      has(this.violations, 'ref') && errors.push(this.violations.ref);

      !this.$v.item.ref.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    ndaErrors() {
      const errors = [];

      if (!this.$v.item.nda.$dirty) return errors;

      has(this.violations, 'nda') && errors.push(this.violations.nda);


      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      !this.$v.item.file.required && errors.push(this.$t('global.field_required'));

      if(this.item.file != null && !this.$v.item.file.maxsizefile){
        if(!this.userHasAccess('unlimited_size_file')){
          errors.push(this.$t('global.sizeerror_100'));
        }
      }

      has(this.violations, 'file') && errors.push(this.violations.file);
      
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  watch: {
    typeSelectItems() {
      this.typePropAssign()
    },
    customerSelectItems() {
      this.customerPropAssign()
    },
    customerProp: function() {
      this.customerPropAssign()
    },
    typeProp: function() {
      this.typePropAssign()
    },
  },

  methods: {
    convertToMo(sizeInBytes) {
      return (sizeInBytes / (1024 * 1024)).toFixed(2);
    },
    ...mapActions({
      typeGetSelectItems: 'designfiletype/fetchSelectItems'
    }),
    ...mapActions({
      tagGetSelectItems: 'tag/fetchSelectItems'
    }),
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems'
    }),
    changeTag() {
      this.item.tags = this.item.tags.map(v => {
        if (typeof v === 'string') {
          v = {
            name: v,
          }
        }
        return v
      })
      this.search = ""

    },
    typePropAssign() {
      if (this.typeProp) {
        for (let i = 0; i < this.typeSelectItems.length; i ++) {
          if (this.typeProp.name === this.typeSelectItems[i].name) {
            this.type = this.typeSelectItems[i]
            this.item.type = this.typeSelectItems[i]
          }
        }
      }
    },
    customerPropAssign() {
      if (this.customerProp) {
        this.customer = this.customerProp;
        this.item.customer = this.customerProp;
      }
    }
  },
  validations() {
    if (this.item['@id']) {
      return {
        item: {
          name: {
            required,
          },
          ref: {
            required,
          },
          type: {

          },
          tags: {
          },
          nda: {
          },
          comment: {
          },
          customer: {
          }

        }
      }
    } else {
      return {
        item: {
          file: {
            required,
            maxsizefile: maxsizefile(100),
          },
          name: {
            required,
          },
          ref: {
            required,
          },
          type: {

          },
          tags: {
          },
          nda: {
          },
          comment: {
          },
          customer: {
          }

        }
      }

    }
  }
  
};
</script>
